import { combineReducers } from 'redux';

import example, { ExampleState } from 'client/ducks/example/reducer';
import app, { ApplicationState } from 'client/ducks/app/reducer';
import homepage, { HomepageState } from 'client/ducks/homepage/reducer';
import outreach, { OutreachState } from 'client/ducks/outreach/reducer';
import eventsPage, { EventsPageState } from 'client/ducks/events-page/reducer';
import projectsPage, { ProjectsPageState } from 'client/ducks/projects-page/reducer';
import datasetsPage, { DatasetsPageState } from 'client/ducks/datasets-page/reducer';
import news, { NewsState } from 'client/ducks/news/reducer';
import publication, { PublicationsState } from 'client/ducks/publications/reducer';
import theme, { ThemesState } from 'client/ducks/themes/reducer';
import researcher, { ResearchersState } from 'client/ducks/researchers/reducer';
import search, { SearchState } from 'client/ducks/search/reducer';

export interface State {
    readonly example: ExampleState;
    readonly app: ApplicationState;
    readonly homepage: HomepageState;
    readonly outreach: OutreachState;
    readonly eventsPage: EventsPageState;
    readonly projectsPage: ProjectsPageState;
    readonly datasetsPage: DatasetsPageState;
    readonly news: NewsState;
    readonly publication: PublicationsState;
    readonly theme: ThemesState;
    readonly researcher: ResearchersState;
    readonly search: SearchState;
}

export default combineReducers<State>({
    example,
    app,
    homepage,
    outreach,
    eventsPage,
    projectsPage,
    datasetsPage,
    news,
    publication,
    theme,
    researcher,
    search
});
